import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import History from "@irati/utils/history"
import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
import {Para as ParaBase} from "@irati/ui/src/Labels"
import ButtonBase from "@irati/ui/src/Button"
import GenericModal from "@irati/ui/src/GenericModal"
import modalImage from "../../../images/ghost.png"

const Para = styled(ParaBase)`
  margin: ${({theme}) => `${theme.spacing.two} 0px ${theme.spacing.eight}`};
`

const Button = styled(ButtonBase)`
  width: 100%;
  margin-bottom: ${({theme}) => theme.spacing.one};
`

interface State {
  show: boolean
}

class ErrorPopup extends PureComponent<InjectIntl, State> {
  state = {
    show: true
  }

  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  handleHide = () =>
    this.setState({
      show: false
    })

  handleAfterExit = () => {
    History.push("/polls", this.context)
  }

  handleClick = () => {
    History.push("/polls", this.context)
  }

  render() {
    const {show} = this.state
    const {formatMessage} = this.props

    return (
      <GenericModal
        show={show}
        image={modalImage}
        onHide={this.handleHide}
        onExited={this.handleAfterExit}
        title={formatMessage({id: "recognition.popup.error.title"})}
        onConfirm={this.handleClick}
        actions={
          <Button primary type="button" onClick={this.handleClick}>
            <FormattedMessage id="recognition.popup.error.button.label" />
          </Button>
        }>
        <Para large center>
          <FormattedMessage id="recognition.popup.error.description" />
        </Para>
      </GenericModal>
    )
  }
}

export default injectIntl(ErrorPopup)
